// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import routers from './router/index'
import iView from 'iview'
import './../src/assets/index.less';
import VueResource from 'vue-resource';
import 'animate.css';
import store from './store/index';

Vue.use(VueResource);
Vue.use(iView);
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: routers,
    hashbang: false,
});

router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    document.title = "万家医疗|连锁健康服务平台-" + to.meta.title;
    next();
});
router.afterEach((to, from, next) => {
    iView.LoadingBar.finish();
});
new Vue({
    store:store,
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js